// Firebase v11 configuration
import { initializeApp } from 'firebase/app'
import { 
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  getRedirectResult,
  signInWithRedirect,
  GoogleAuthProvider,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
} from 'firebase/auth'
import { 
  getDatabase,
  ref,
  get,
  set,
  push,
  update,
  remove,
  onValue,
  off,
  child,
  serverTimestamp,
  query,
  orderByChild,
  orderByValue,
  startAt,
  endAt,
  equalTo,
  limitToFirst,
  onChildAdded
} from 'firebase/database'
import { 
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyAigK9xO4n0T8iSIg8sIB88ybyJJ_Vq2TA',
  authDomain: 'stadium-data.firebaseapp.com',
  databaseURL: 'https://stadium-data.firebaseio.com',
  projectId: 'stadium-data',
  storageBucket: 'stadium-data.appspot.com',
  messagingSenderId: '360504160008'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const database = getDatabase(app)
export const storage = getStorage(app)

// Export auth functions
export {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  firebaseSignOut as signOut,
  getRedirectResult,
  signInWithRedirect,
  GoogleAuthProvider,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword
}

// Export database functions
export {
  ref,
  get,
  set,
  push,
  update,
  remove,
  onValue,
  off,
  child,
  serverTimestamp,
  query,
  orderByChild,
  orderByValue,
  startAt,
  endAt,
  equalTo,
  limitToFirst,
  onChildAdded
}

// Export storage functions
export {
  storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject
}

export default app
